import { render, staticRenderFns } from "./CrystoLogo.vue?vue&type=template&id=070084c6&scoped=true"
import script from "./CrystoLogo.vue?vue&type=script&lang=js"
export * from "./CrystoLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070084c6",
  null
  
)

export default component.exports